import { Component, Injector, Input, ViewEncapsulation, EventEmitter, Output, OnInit } from '@angular/core';
import {AbstractControl, ControlContainer, FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import { AppComponentBase } from '@shared/common/app-component-base';
import { VirtualBankAccountDto } from '../../../../shared/service-proxies/service-proxies';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';


@Component({
    selector: 'billingInformation',
    templateUrl: './billing-information.component.html',
    styleUrls: ['./billing-information.component.less'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    encapsulation: ViewEncapsulation.None
})
export class BillingInformationComponent extends AppComponentBase implements OnInit {
    protected readonly BasePermissionDefinition = BasePermissionDefinition;

    //Show EmailField
    @Input() showEmailField = false;
    //BankCustomerInput object
    @Input() billingInfo: VirtualBankAccountDto;

    @Input() billingInfoValidator?: BillingInfoValidator;

    @Input() billingInfoForm!: FormGroup;

    @Input() editUsersProfile = false;
    @Input() editUsersProfileVisitor = false;
    @Input() editUsersProfileFinancial = false;
    @Input() editUsersProfileInvoice = false;
    @Input() editUsersProfileDelivery = false;

    constructor(
        injector: Injector
    ) {
        super(injector);
    }

    ngOnInit(): void {

    }

    isControlRequired(controlName: string): boolean {
        const control = this.billingInfoForm?.get(controlName);
        if (!control) {
            return false;
        }

        const validator = control.validator ? control.validator({} as AbstractControl) : null;
        return !!(validator && validator.required);
    }

    //openPaymentTermsModal() {
    //    this.openPaymentTerms.emit(true);
    //}
}

export class BillingInfoValidator {
    requiredVisitorBlock: boolean;
    requiredInvoiceBlock: boolean;
    requiredDeliveryBlock: boolean;
    requiredSearchBlock?: boolean;
    requiredCompanyDataBlock?: boolean;

    // New optional properties
    requiredVisitorLegalName?: boolean;
    requiredVisitorContactName?: boolean;
    requiredVisitorAddress?: boolean;
    requiredVisitorAddressHouseNumber?: boolean;
    requiredVisitorAddressPostcode?: boolean;
    requiredVisitorAddressCity?: boolean;
    requiredVisitorAddressCountry?: boolean;

    requiredInvoiceContactName?: boolean;
    requiredInvoiceAddress?: boolean;
    requiredInvoiceAddressHouseNumber?: boolean;
    requiredInvoiceAddressPostcode?: boolean;
    requiredInvoiceAddressCity?: boolean;
    requiredInvoiceAddressCountry?: boolean;

    requiredDeliveryContactName?: boolean;
    requiredDeliveryAddress?: boolean;
    requiredDeliveryAddressHouseNumber?: boolean;
    requiredDeliveryAddressPostcode?: boolean;
    requiredDeliveryAddressCity?: boolean;
    requiredDeliveryAddressCountry?: boolean;

    requiredContactName?: boolean;
    requiredPhoneNumber?: boolean;
    requiredPhoneNumberSecondary?: boolean;
    requiredInvoiceEAddress?: boolean;
    requiredInvoiceRememberEInvoiceAddress?: boolean;

    requiredAccountBankName?: boolean;
    requiredAccountNumber?: boolean;
    requiredRegistrationNo?: boolean;
    requiredTaxVatNo?: boolean;

    constructor(init?: Partial<BillingInfoValidator>) {
        Object.assign(this, init);
    }

    getValidator(field: keyof BillingInfoValidator, relatedBlock: keyof BillingInfoValidator): Validators | null {
        return this[field] || this[relatedBlock] ? Validators.required : null;
    }

}
